/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Users from "layouts/users";
import Customers from "layouts/customers";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import AddUser from "layouts/add_user";
import EditUser from "layouts/edit_user";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
// import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import EditCurrentUser from "layouts/edit_current_user";
import Orders from "layouts/orders";
import Payments from "layouts/payments";
import CustomerPayments from "layouts/customer_payments";
import Suppliers from "layouts/suppliers";
import CustomerSuppliers from "layouts/customer_suppliers";
import AddOrder from "layouts/add_order";
import Transactions from "layouts/transactions";
import BackUpData from "layouts/back_up";
import EditPasswordUser from "layouts/edit_password_current_user";
import TestUsers from "layouts/users/test";
import ReciveGoods from "layouts/recive_goods";
import AddTransaction from "layouts/add_transaction";
import Totals from "layouts/totals/totals";
import AddContainer from "layouts/add_container";
import Containers from "layouts/containers";
import AddCustomer from "layouts/add_customer";
import AllOrders from "layouts/all_orders";
import Posts from "layouts/posts";
import AddPost from "layouts/add_post";
import HomeScreen from "layouts/home_screen";
import Messages from "layouts/messages";
import AddMessage from "layouts/add_message";
import ViewOrder from "layouts/view_order";
import Status from "layouts/status";
import AddStatus from "layouts/add_status";
import EditStatus from "layouts/edit_status";
import ViewContainer from "layouts/view_container";
import EditCustomer from "layouts/edit_customer";
import EditContainer from "layouts/edit_container";
import EditOrder from "layouts/edit_order";
import CustomerOrders from "layouts/customer_orders";
import EditMessage from "layouts/edit_message";
import ContainersDetails from "layouts/containers_details";
import AllOrdersCustomers from "layouts/all_orders_customers";
import EditOrderMainData from "layouts/edit_order_main_data";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Home Screen",
    key: "homescreen",
    route: "/homescreen",
    icon: <Shop size="12px" />,
    component: <HomeScreen />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Containers",
    key: "containers",
    route: "/containers",
    icon: <Office size="12px" />,
    component: <Containers />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Status",
    key: "status",
    route: "/status",
    icon: <Office size="12px" />,
    component: <Status />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Posts",
    key: "posts",
    route: "/posts",
    icon: <Office size="12px" />,
    component: <Posts />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <Office size="12px" />,
    component: <Users />,
    noCollapse: true,
  },
  {
    // Merged into the Users tab, which filters on role_id. The route stays
    // registered (getRoutes only needs `route`), so add/edit customer links
    // keep working - only the tab is gone.
    type: "hidden",
    name: "Customers",
    key: "customers",
    route: "/customers",
    icon: <Office size="12px" />,
    component: <Customers />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    route: "/messages",
    icon: <Office size="12px" />,
    component: <Messages />,
    noCollapse: true,
  },

  {
    // No longer needed as a tab; route kept so old links still resolve.
    type: "hidden",
    name: "All Orders",
    key: "all_orders",
    route: "/all_orders",
    icon: <Office size="12px" />,
    component: <AllOrders />,
    noCollapse: true,
  },

  {
    // money OUT, to suppliers
    type: "collapse",
    name: "Payments",
    key: "payments",
    route: "/payments",
    icon: <Office size="12px" />,
    component: <Payments />,
    noCollapse: true,
  },
  {
    // money IN, from customers - the PAYMENT sheet rebuild. Kept off the tab
    // bar because Payments is the suppliers ledger now, but still reachable
    // at /customer_payments and one line from being a tab again.
    type: "hidden",
    name: "Customer Payments",
    key: "customer_payments",
    route: "/customer_payments",
    icon: <Office size="12px" />,
    component: <CustomerPayments />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Suppliers",
    key: "suppliers",
    route: "/suppliers",
    icon: <Office size="12px" />,
    component: <Suppliers />,
    noCollapse: true,
  },
  {
    // the same supplier data grouped by customer, which is how the office
    // asks the question: "who is AKT buying from and what is still owed"
    type: "collapse",
    name: "Customer Suppliers",
    key: "customer_suppliers",
    route: "/customer_suppliers",
    icon: <Office size="12px" />,
    component: <CustomerSuppliers />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    route: "/transactions",
    icon: <Office size="12px" />,
    component: <Transactions />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    route: "/orders",
    icon: <Office size="12px" />,
    component: <Orders />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customer Orders",
    key: "customer_orders",
    route: "/customer_orders",
    icon: <Office size="12px" />,
    component: <CustomerOrders />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Container Details",
    key: "container_orders",
    route: "/container_orders/:id",
    icon: <Office size="12px" />,
    component: <ContainersDetails />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customer Order Details",
    key: "customer_order_details",
    route: "/customer_order_details",
    icon: <Office size="12px" />,
    component: <AllOrdersCustomers />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "View Order",
    key: "view_order",
    route: "/view_order/:id",
    icon: <Office size="12px" />,
    component: <ViewOrder />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "View Container",
    key: "view_container",
    route: "/view_container/:id",
    icon: <Office size="12px" />,
    component: <ViewContainer />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Container",
    key: "edit_container",
    route: "/edit_container/:id",
    icon: <Office size="12px" />,
    component: <EditContainer />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Message",
    key: "edit_message",
    route: "/edit_message/:id",
    icon: <Office size="12px" />,
    component: <EditMessage />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Virtual Reality",
    key: "virtual-reality",
    route: "/virtual-reality",
    icon: <Cube size="12px" />,
    component: <VirtualReality />,
    noCollapse: true,
  },

  { type: "title", title: "Account Pages", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    icon: <SpaceShip size="12px" />,
    component: <SignUp />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "add_user",
    route: "/add_user",
    icon: <SpaceShip size="12px" />,
    component: <AddUser />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit User",
    key: "edit_user",
    route: "/edit_user/:id",
    icon: <SpaceShip size="12px" />,
    component: <EditUser />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Order",
    key: "edit_order",
    route: "/edit_order/:id",
    icon: <SpaceShip size="12px" />,
    component: <EditOrder />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Order",
    key: "edit_order_data",
    route: "/edit_order_data/:id",
    icon: <SpaceShip size="12px" />,
    component: <EditOrderMainData />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Add Post",
    key: "add_post",
    route: "/add_post",
    icon: <SpaceShip size="12px" />,
    component: <AddPost />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Add Message",
    key: "add_message",
    route: "/add_message",
    icon: <SpaceShip size="12px" />,
    component: <AddMessage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Add Status",
    key: "add_status",
    route: "/add_status",
    icon: <SpaceShip size="12px" />,
    component: <AddStatus />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Status",
    key: "edit_status",
    route: "/edit_status/:id",
    icon: <SpaceShip size="12px" />,
    component: <EditStatus />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Add Transaction",
    key: "add_transaction",
    route: "/add_transaction",
    icon: <SpaceShip size="12px" />,
    component: <AddTransaction />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Add Order",
    key: "add_order",
    route: "/add_order",
    icon: <SpaceShip size="12px" />,
    component: <AddOrder />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Recive Goods",
    key: "recive_goods",
    route: "/recive_goods",
    icon: <SpaceShip size="12px" />,
    component: <ReciveGoods />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Totals",
    key: "totals",
    route: "/totals",
    icon: <Office size="12px" />,
    component: <Totals />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Add Container",
    key: "add_container",
    route: "/add_container",
    icon: <SpaceShip size="12px" />,
    component: <AddContainer />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Add Customer",
    key: "add_customer",
    route: "/add_customer",
    icon: <SpaceShip size="12px" />,
    component: <AddCustomer />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Password Current User",
    key: "edit_current_user_password",
    route: "/edit_current_user_password",
    icon: <SpaceShip size="12px" />,
    component: <EditPasswordUser />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Edit Customer",
    key: "edit_customer",
    route: `/edit_customer/:customer_id`,
    icon: <SpaceShip size="12px" />,
    component: <EditCustomer />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Edit Current User",
    key: "edit_current_user",
    route: "/edit_current_user",
    icon: <SpaceShip size="12px" />,
    component: <EditCurrentUser />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Payments",
    key: "payments",
    route: "/payments",
    icon: <Document size="12px" />,
    component: <Containers />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Suppliers",
    key: "suppliers",
    route: "/suppliers",
    icon: <Office size="12px" />,
    component: <Suppliers />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Back Up",
    key: "back_up",
    route: "/back_up",
    icon: <Document size="12px" />,
    component: <BackUpData />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "TestANas",
    key: "back_up",
    route: "/back_up",
    icon: <Document size="12px" />,
    component: <TestUsers />,
    noCollapse: true,
  },
];

export default routes;
